import {
  getLinks,
  AcceptedLinksStarts,
  StoryblokGetLinksResponse,
} from '@cinch-nx/data-storyblok'
import { GetStaticPathsResult } from 'next/types'

type Path = { params: { slug: string } }

const convertStoryblokLinksToStaticPaths = ({
  links,
}: {
  links: StoryblokGetLinksResponse['links']
}) => {
  const paths: Path[] = []

  for (const linkKey of Object.keys(links)) {
    if (links[linkKey].is_folder) {
      continue
    }

    const slug = links[linkKey].slug.split('/')[1]

    paths.push({ params: { slug } })
  }

  return paths
}

export const getStaticPathsFromStoryblokSlugGenerator =
  (slug: string) => async (): Promise<GetStaticPathsResult> => {
    try {
      const links = await getLinks(slug as AcceptedLinksStarts)
      const paths = convertStoryblokLinksToStaticPaths({ links })
      return { paths, fallback: 'blocking' }
    } catch {
      return { paths: [], fallback: 'blocking' }
    }
  }
